import React, { useEffect, useState } from 'react'
import routes from '../../../routes'
import { useLocation } from 'react-router-dom'
import objectPath from 'object-path'
import { ROUTE_HIS } from '../action/Config'

const PathComponent = () => {
  const location = useLocation()
  let urlSearchParams = new URLSearchParams(location.search || [])
  let receiveQueryParams = Object.fromEntries([...urlSearchParams])
  let componentPath = objectPath.get(receiveQueryParams, 'component') || ''
  const [foundComponent, setFoundComponent] = useState(null)
  const [Component, setComponent] = useState(<></>)

  useEffect(() => {
    if (componentPath) {
      let queryParams = Object.keys(receiveQueryParams)
      let queryString = []
      queryParams.forEach((param) => {
        if (param === 'component') return
        let value = objectPath.get(receiveQueryParams, param)
        if (value) {
          queryString.push(`${param}=${value}`)
        }
      })
      let pathname = location.pathname
      if (queryString.length > 0) {
        pathname = pathname + '?' + queryString.join('&')
      }
      window.open(ROUTE_HIS + pathname, '_self')
    }
  }, [location.pathname])

  useEffect(() => {
    let foundComponent
    let subRoute = routes.find((route) => {
      return componentPath.startsWith(route.path)
    })
    let mainRoute = routes.find((route) => {
      return route.routes && route.path === '*'
    })

    if (subRoute) {
      let { path, routes } = subRoute
      let subPath = componentPath.replace(path, '')
      if (routes) {
        foundComponent = routes.find(({ path }) => {
          let splitPath = path.split('/').filter((path) => path)
          let splitSubPath = subPath.split('/').filter((path) => path)
          if (splitPath.length === splitSubPath.length) {
            let filterPath = splitPath.filter((item, index) => {
              return item === '*' || item === splitSubPath[index]
            })
            if (filterPath.length === splitPath.length) {
              return true
            }
          }
          return false
        })
      } else {
        foundComponent = subRoute
      }
    } else if (mainRoute) {
      let { routes = [] } = mainRoute
      foundComponent = routes.find(({ path }) => path === componentPath)
    }
    if (foundComponent && foundComponent.component) {
      let Component = foundComponent.component
      setFoundComponent(foundComponent)
      setComponent(Component)
    } else {
      setFoundComponent(null)
      setComponent(<></>)
    }
  }, [componentPath])

  if (componentPath && foundComponent) {
    return <Component />
  }

  return <></>
}

export default PathComponent
